export default __webpack_public_path__ + "static/media/email.4b1e08b2.png";